function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  id: "canvas_background",
  height: 252,
  width: 252,
  y: -1,
  x: -1
}), /*#__PURE__*/React.createElement("g", {
  display: "none",
  overflow: "visible",
  y: 0,
  x: 0,
  height: "100%",
  width: "100%",
  id: "canvasGrid"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "url(#gridpattern)",
  strokeWidth: 0,
  y: 0,
  x: 0,
  height: "100%",
  width: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg_15",
  x1: 0,
  y1: 0,
  x2: 1,
  y2: 0
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#eeeeee",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#eeeeee",
  offset: 1
}))), /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_27"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  transform: "matrix(0.9841270262286749,0,0,0.9841270262286749,-769.1009829619807,-769.1009829619807) ",
  id: "svg_24"
}, /*#__PURE__*/React.createElement("title", {
  stroke: "null",
  transform: "translate(-28.541780471801758,0) translate(0,-33.62236785888672) translate(28.45161247253418,33.532257080078125) translate(-216.38790893554688,-216.38790893554688) translate(1000,0) translate(0,1000) "
}, "background"), /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  x: 782.521923,
  y: 782.52198,
  width: 252,
  height: 252,
  id: "svg_22",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_21",
  display: "none"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "null",
  id: "svg_25",
  width: 250,
  height: 250,
  x: 783.521923,
  y: 783.52198,
  strokeWidth: 0,
  fill: "url(#gridpattern)"
}))), /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  transform: "matrix(0.9841270262286749,0,0,0.9841270262286749,-769.1009829619807,-769.1009829619807) ",
  id: "svg_26"
}, /*#__PURE__*/React.createElement("title", {
  stroke: "null",
  transform: "translate(-28.541780471801758,0) translate(0,-33.62236785888672) translate(28.45161247253418,33.532257080078125) translate(-216.38790893554688,-216.38790893554688) translate(1000,0) translate(0,1000) "
}, "Layer 1"), /*#__PURE__*/React.createElement("defs", {
  stroke: "null",
  transform: "translate(-28.541780471801758,0) translate(0,-33.62236785888672) translate(28.45161247253418,33.532257080078125) translate(-216.38790893554688,-216.38790893554688) translate(1000,0) translate(0,1000) "
}, /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  d: "m210,460l0,-130c22.66,0 36.82,0 42.48,0c37.17,0 71.5,-19.87 90.01,-52.1c5.5,-9.58 -3.11,5.41 3.59,-6.26c14.87,-25.88 15.26,-57.62 1.03,-83.86c-6.55,-12.09 1.76,3.24 -3.53,-6.51c-18.02,-33.25 -52.81,-53.96 -90.63,-53.96c-11.06,0 -38.71,0 -82.95,0",
  id: "svg_20"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  d: "m233.39,394.19c25.16,0 40.89,0 47.18,0c5.24,0 10.24,-2.14 13.86,-5.93c5.03,-5.28 7.6,-10.18 7.72,-14.7c0.14,-5.02 -2.78,-10.02 -8.76,-15c-2.99,-2.49 -6.75,-3.85 -10.64,-3.85c-6.58,0 -23.03,0 -49.36,0",
  id: "svg_18"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "null",
  d: "m238,460l0,-23.97c28.99,0.05 47.12,0.08 54.36,0.09c3.53,0.01 6.9,-1.41 9.36,-3.93c5.39,-5.52 8.15,-10.88 8.28,-16.06c0.13,-5.2 -2.63,-11.05 -8.28,-17.53c-2.44,-2.8 -5.98,-4.41 -9.69,-4.41c-7.2,0 -25.21,0 -54.03,0",
  id: "svg_16"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "null",
  id: "svg_13",
  transform: "matrix(0.6323201625661279,0,0,0.6323201625661279,-786.2393381772439,-823.9550632661224) "
}, /*#__PURE__*/React.createElement("use", {
  stroke: "url(#svg_15)",
  xlinkHref: "#svg_20",
  fillOpacity: 0,
  strokeWidth: 20,
  id: "svg_19",
  y: 2446.218072,
  x: 2416.469356
}), /*#__PURE__*/React.createElement("use", {
  stroke: "url(#svg_15)",
  xlinkHref: "#svg_18",
  fillOpacity: 0,
  strokeWidth: 20,
  id: "svg_17",
  y: 2446.218072,
  x: 2416.469356
}), /*#__PURE__*/React.createElement("use", {
  stroke: "url(#svg_15)",
  xlinkHref: "#svg_16",
  fillOpacity: 0,
  strokeWidth: 20,
  id: "svg_14",
  y: 2446.218072,
  x: 2416.469356
})))));

function SvgPblogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPblogo);
export default __webpack_public_path__ + "static/media/pblogo.e85ffd6c.svg";
export { ForwardRef as ReactComponent };